import { useMutation, useQueryClient } from 'react-query'
import { useToast } from '@chakra-ui/react'

import { fetchAPI } from '@/lib/api'
import { getErrorMsg, t } from '@/lib/helpers'

import { GARBAGES } from '../constants'

const deleteGarbage = async (id: number) => {
  await fetchAPI({
    path: `/garbages/${id}`,
    method: 'delete',
  })
}

export const useDeleteGarbage = () => {
  const toast = useToast()
  const queryClient = useQueryClient()

  return useMutation(deleteGarbage, {
    async onSuccess() {
      await queryClient.refetchQueries([GARBAGES])

      toast({
        description: t('views.admin.garbages.services.delete_success'),
        status: 'success',
        position: 'top-right',
        isClosable: true,
      })
    },
    onError(error) {
      toast({
        description: getErrorMsg(error),
        status: 'error',
        position: 'top-right',
        variant: 'left-accent',
        isClosable: true,
      })
    },
  })
}
